import React, { useEffect, useRef, useState } from "react";
import "./header.scss";
import ImageElement from "../components/ImageElement";
import {
  Badge,
  Button,
  Nav,
  NavDropdown,
  Navbar,
  Form,
  NavItem,
} from "react-bootstrap";
import CustomModal from "./CustomModal";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/loginSlice";
// import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import apiRequest from "../services/api";
import { Link, useNavigate, useLocation } from "react-router-dom"; // Add useLocation import
import { Roles } from "../constants";

// import { Form } from 'react-router-dom';

// import React, { useState } from 'react';
// import { Button, Nav, NavDropdown, Navbar, Form } from 'react-bootstrap';
// import CustomModal from './CustomModal';
// import ImageElement from '../components/ImageElement';

export default function Header() {
  const user_role = useSelector((state) => state?.auth?.role || "");
  const wp_token = useSelector(
    (state) => state?.auth?.userInfo?.wp_token || ""
  );
  const user_id = useSelector((state) => state?.auth?.userInfo?.id || "");
  const [user_info, setUser_info] = useState(
    useSelector((state) => state?.auth?.userInfo || {})
  );
  console.log("🚀 ~ Header ~ user_info:", user_info);

  const token = useSelector((state) => state?.auth?.token || "");
  const image = useSelector((state) => state?.auth?.profile_image || "");
  const qrImage = useSelector((state) => state?.auth?.userInfo?.qr_code_url);
  const qrLink = useSelector((state) => state?.auth?.userInfo?.deeplink_url);
  const [CartCount, setCartCount] = useState(0);
  const [NotificationType, setNotificationType] = useState("");
  const notificationIntervalRef = useRef(null);
  const cartIntervalRef = useRef(null);
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxLogout = () => {
    dispatch(logout());
  };
  const handleResouces = () => {};
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setQRModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
  };
  const [QRModal, setQRModal] = useState(false);
  const share_qr = () => {
    console.log("share qr");
    setQRModal(true);
  };
  const [notificationDataToDisplay, setNotificationDataToDisplay] = useState(
    []
  );

  const copyTextToClipboard = (text) => {
    if (!text) return; // Do nothing if text is empty or undefined
    window.navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied");
        console.log("Text copied to clipboard");
      })
      .catch((error) => {
        console.error("Failed to copy text: ", error);
      });
  };
  const [NotificationData, setNotificationData] = useState([]);
  const fetchNotifications = (type) => {
    setNotificationType(type);
    let params = {
      method: "GET",
      endpoint: "api/users/notifications",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    };
    apiRequest(params)
      .then((response) => {
        setNotificationData(response?.data?.data?.notifications?.slice(0, 3));
        setNotificationDataToDisplay(
          response?.data?.data?.notifications?.slice(0, 3)
        );
      })
      .catch((error) => {
        // toast.error("Something went wrong!");
      });
  };

  const switchNotificationType = (type) => {
    setNotificationType(type);
    if (type === "unread") {
      setNotificationDataToDisplay(
        NotificationData.filter((item) => item?.status === 0)
      );
    } else {
      setNotificationDataToDisplay(NotificationData);
    }
  };

  const [RedDot, setRedDot] = useState(false);
  const HandleLogout = () => {
    let params = {
      method: "POST",
      endpoint: "user/logout",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      data: {
        user_id,
      },
    };
    apiRequest(params)
      .then((response) => {
        // setNotificationData(response?.data?.data?.slice(0, 3));
      })
      .catch((error) => {
        toast.error("Something went wrong!");
      });
  };

  let checkNoti = () => {
    let params = {
      method: "GET",
      endpoint: "api/users/notifications/count",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    };
    apiRequest(params)
      .then((response) => {
        if (response?.data?.data) {
          setRedDot(true);
        } else {
          setRedDot(false);
        }
      })
      .catch((error) => {
        toast.error(
          "Your session has expired. Please signup or login again to continue."
        );
      });
  };

  useEffect(() => {
    // dont run for guest
    if (user_role === Roles.GUEST) {
      return;
    }
    const cartCountInterval = setInterval(() => {
      let params = {
        method: "GET",
        endpoint: "api/users/carts/count",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {},
      };
      apiRequest(params)
        .then((response) => {
          if (response?.data?.success) {
            console.log(
              "🚀 ~ .then ~ response?.data?.count:",
              response?.data?.count
            );
            setCartCount(response?.data?.data || 0);
          } else {
          }
        })
        .catch((error) => {});
    }, 5000);
    const notificationCountInterval = setInterval(() => {
      checkNoti();
    }, 10000);
    if (!notificationIntervalRef.current) {
      notificationIntervalRef.current = notificationCountInterval;
    }
    if (!cartIntervalRef.current) {
      cartIntervalRef.current = cartCountInterval;
    }
    return () => {
      clearInterval(notificationIntervalRef.current);
      clearInterval(cartIntervalRef.current);
      notificationIntervalRef.current = null;
      cartIntervalRef.current = null;
    };
  }, []);

  const location = useLocation(); // Add this hook

  return (
    <>
      {/* <div> */}
      <Navbar
        id="header"
        className="header px-3 py-3 assesso-header"
        variant="dark"
        expand="lg"
        sticky="top"
      >
        <div className="d-flex align-items-start align-items-md-center justify-content-center w-100">
          <Navbar.Brand className="logo d-flex flex-md-row flex-column align-items-start align-items-md-start text-decoration-none">
            <a
              href={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/?t=${wp_token}`}
              style={{
                color: "inherit",
                textDecoration: "none",
                display: "flex",
              }}
            >
              {/* <ImageElement source={"asesso-logo.svg"} alt={"Asesso logo"} /></a> */}
              <span className="d-flex">
                <svg
                  width="102"
                  height="21"
                  viewBox="0 0 102 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.0221 15.8316C11.3775 15.8316 8.30893 13.1108 7.8772 9.49863L7.36102 5.17969C3.88155 5.35684 1.00365 8.01319 0.5871 11.5032L0.0310671 16.1632C-0.276364 18.7371 1.73712 21.0003 4.33225 21.0003H11.1318C13.7279 21.0003 15.7404 18.7362 15.433 16.1632L15.3922 15.8221C15.2698 15.8269 15.1464 15.8316 15.0221 15.8316Z"
                    fill="#69CDFF"
                  />
                  <path
                    d="M18.4209 0H11.6213C9.02525 0 7.01271 2.26415 7.32014 4.83714L7.36094 5.17818C7.48429 5.17155 7.60765 5.16776 7.73195 5.16776C11.3765 5.16776 14.4451 7.88853 14.8769 11.5008L15.3931 15.8197C18.8725 15.6425 21.7504 12.9862 22.167 9.49617L22.723 4.83619C23.0304 2.26415 21.017 0 18.4209 0Z"
                    fill="#2364E1"
                  />
                  <path
                    d="M7.73184 5.16797C7.60754 5.16797 7.48419 5.17176 7.36084 5.17839L7.87702 9.49733C8.30875 13.1105 11.3774 15.8303 15.0219 15.8303C15.1462 15.8303 15.2696 15.8265 15.3929 15.8199L14.8768 11.501C14.445 7.88874 11.3764 5.16797 7.73184 5.16797Z"
                    fill="#379BFF"
                  />
                  <path
                    d="M26.2993 13.1928V12.6973C28.0879 12.6443 28.3356 12.2379 29.6991 9.00267L33.1871 0.287109H33.6122L37.0651 9.17983C38.3043 12.3449 38.4817 12.5922 40.0758 12.6983V13.1937H34.2849V12.6983C36.4094 12.6452 36.1447 12.5041 34.9928 9.35698L34.8153 8.86152H30.4772L30.406 9.03867C29.1136 12.1857 28.9713 12.6452 31.2381 12.6983V13.1937H26.2993V13.1928ZM34.6218 8.331L32.7098 3.07988L30.6736 8.331H34.6218Z"
                    fill="white"
                  />
                  <path
                    d="M46.4498 13.5458C44.1128 13.5458 43.2265 12.6439 42.643 12.6439C42.3242 12.6439 41.9522 12.785 41.882 13.4037H41.3687V8.36474H41.8288C42.4665 11.3176 44.1659 12.9442 46.167 12.9442C47.8674 12.9442 48.8409 11.9192 48.8409 10.5218C48.8409 6.65004 41.8108 8.54189 41.8108 3.76822C41.8108 1.70017 43.5283 0.179688 45.9545 0.179688C47.9205 0.179688 48.5933 0.975456 48.9823 0.975456C49.3362 0.975456 49.5317 0.816303 49.6551 0.250738H50.1153V4.9003H49.6551C49.1057 2.05353 47.8133 0.728199 46.0608 0.728199C44.591 0.728199 43.5814 1.63007 43.5814 3.15056C43.5814 6.70404 50.8592 4.9543 50.8592 9.74502C50.8592 12.4326 48.4149 13.5458 46.4498 13.5458Z"
                    fill="white"
                  />
                  <path
                    d="M59.8546 9.53402C59.7132 7.53607 58.863 7.11166 57.2158 7.11166H55.9405V8.7913C55.9405 12.3097 56.1531 12.6631 59.0044 12.6631H59.1107C61.8557 12.6631 63.0949 11.3018 63.9451 9.86938L64.299 10.0105L63.5381 13.1927H52.0635V12.6972C53.9935 12.6441 54.0466 12.2377 54.0466 8.82541V4.95361C54.0466 1.54128 53.9935 1.13487 52.0635 1.06382V0.568359H62.7761L62.9536 3.62733L62.5636 3.69838C61.9791 1.87759 60.8632 1.09982 58.5442 1.09982H55.9415V6.5802H57.2167C58.864 6.5802 59.7132 6.15579 59.8555 4.15784H60.3689V9.53213H59.8546V9.53402Z"
                    fill="white"
                  />
                  <path
                    d="M70.7633 13.5458C68.4262 13.5458 67.54 12.6439 66.9564 12.6439C66.6376 12.6439 66.2657 12.785 66.1955 13.4037H65.6821V8.36474H66.1423C66.78 11.3176 68.4794 12.9442 70.4805 12.9442C72.1809 12.9442 73.1544 11.9192 73.1544 10.5218C73.1544 6.65004 66.1243 8.54189 66.1243 3.76822C66.1243 1.70017 67.8417 0.179688 70.268 0.179688C72.234 0.179688 72.9068 0.975456 73.2958 0.975456C73.6497 0.975456 73.8452 0.816303 73.9685 0.250738H74.4287V4.9003H73.9685C73.4201 2.05353 72.1268 0.728199 70.3742 0.728199C68.9045 0.728199 67.8949 1.63007 67.8949 3.15056C67.8949 6.70404 75.1726 4.9543 75.1726 9.74502C75.1717 12.4326 72.7284 13.5458 70.7633 13.5458Z"
                    fill="white"
                  />
                  <path
                    d="M81.9864 13.5458C79.6494 13.5458 78.7631 12.6439 78.1796 12.6439C77.8608 12.6439 77.4888 12.785 77.4186 13.4037H76.9053V8.36474H77.3655C78.0031 11.3176 79.7025 12.9442 81.7037 12.9442C83.404 12.9442 84.3776 11.9192 84.3776 10.5218C84.3776 6.65004 77.3474 8.54189 77.3474 3.76822C77.3474 1.70017 79.0649 0.179688 81.4911 0.179688C83.4572 0.179688 84.1299 0.975456 84.5189 0.975456C84.8729 0.975456 85.0683 0.816303 85.1917 0.250738H85.6519V4.9003H85.1917C84.6423 2.05353 83.3499 0.728199 81.5974 0.728199C80.1276 0.728199 79.118 1.63007 79.118 3.15056C79.118 6.70404 86.3958 4.9543 86.3958 9.74502C86.3958 12.4326 83.9525 13.5458 81.9864 13.5458Z"
                    fill="white"
                  />
                  <path
                    d="M89.9826 11.5888C87.4407 9.05086 86.8647 4.97539 89.8327 2.01305C92.8131 -0.962557 96.9074 -0.399835 99.4494 2.1381C101.979 4.66372 102.555 8.76382 99.5747 11.7394C96.6057 14.7018 92.5114 14.1144 89.9826 11.5888ZM90.3584 11.2137C92.3368 13.1889 95.3665 12.7891 97.9967 10.164C100.638 7.52659 101.052 4.48846 99.0737 2.51325C97.0953 0.538035 94.0523 0.95013 91.4107 3.58848C88.7804 6.21357 88.38 9.23844 90.3584 11.2137Z"
                    fill="white"
                  />
                  <path
                    d="M26.2998 17.2031H26.7951V18.8648H29.1274V17.2031H29.618V20.9991H29.1274V19.2949H26.7951V20.9991H26.2998V17.2031Z"
                    fill="white"
                  />
                  <path
                    d="M34.4268 17.2012H37.1035V17.6152H34.9221V18.8675H37.0874V19.2815H34.9221V20.5832H37.1035V20.9972H34.4268V17.2012Z"
                    fill="white"
                  />
                  <path
                    d="M44.3742 19.9759H42.2734L41.837 20.9972H41.3037L42.968 17.2012H43.674L45.3383 20.9972H44.8154L44.3742 19.9759ZM44.1968 19.5563L43.3295 17.5394H43.3191L42.4575 19.5563H44.1968Z"
                    fill="white"
                  />
                  <path
                    d="M49.7651 17.2012H50.2604V20.5671H51.8004V20.9972H49.7651V17.2012Z"
                    fill="white"
                  />
                  <path
                    d="M56.5134 17.6313H55.3179V17.2012H58.1996V17.6313H57.004V20.9972H56.5144V17.6313H56.5134Z"
                    fill="white"
                  />
                  <path
                    d="M62.6636 17.2012H63.1589V18.8628H65.4912V17.2012H65.9817V20.9972H65.4912V19.2929H63.1589V20.9972H62.6636V17.2012Z"
                    fill="white"
                  />
                </svg>
              </span>
            </a>

            <span className="d-flex text-white ps-md-2 ps-0 ms-md-2 ms-0 dashboard-link">
              {useSelector((state) =>
                user_role === Roles.PATIENT || user_role === Roles.GUEST ? (
                  <Link
                    to={"/patient_dashboard"}
                    className="text-white text-decoration-none"
                  >
                    Patient Dashboard
                  </Link>
                ) : (
                  <Link
                    to={"/dentist_portal"}
                    className="text-white text-decoration-none"
                  >
                    Doctor Portal Dashboard
                  </Link>
                )
              )}
            </span>
          </Navbar.Brand>

          <Nav className="ms-auto d-flex align-content-center justify-content-center">
            {user_role === Roles.DENTIST ? (
              <Nav>
                {" "}
                <Link to={"/grind_guard"}>
                  <button
                    type="button"
                    className={`default-button primary-button border-0 rounded-pill text-center text-white btn btn-primary px-4 ${
                      location.pathname === "/grind_guard" ? "active" : ""
                    }`}
                  >
                    Buy Now
                  </button>
                </Link>
              </Nav>
            ) : null}
            {[Roles.PATIENT, Roles.DENTIST].includes(user_role) && (
              <>
                <NavItem
                  className="d-flex align-items-center justify-content-center cart me-2 me-md-2"
                  onClick={() => navigate("/checkout/?products=")}
                >
                  <ImageElement source={"cart_icon.svg"} alt={"cart"} />
                  <Badge pill className={`ms-2 bgBlue`}>
                    {CartCount || 0}
                  </Badge>
                </NavItem>
              </>
            )}

            {[Roles.PATIENT, Roles.DENTIST].includes(user_role) && (
              <NavDropdown
                title={
                  <>
                    <ImageElement source={"bellIcon.svg"} alt={"bell"} />
                    {RedDot ? (
                      <Badge pill className={`ms-2 bgRed`}></Badge>
                    ) : (
                      ""
                    )}
                  </>
                }
                className="notification-dropdown me-2 mx-md-2"
                id="notification-dropdown"
                onClick={() => fetchNotifications("all")}
              >
                <NavDropdown.Header>
                  <h5 className="mb-0 text-black">Notifications</h5>
                </NavDropdown.Header>

                <NavDropdown.Divider />
                <div className="pt-2">
                  <ul className="p-0 notification-ul">
                    <li className="d-inline">
                      <button
                        className={`rounded-pill ${
                          NotificationType === "all" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          switchNotificationType("all");
                        }}
                      >
                        All
                      </button>
                    </li>
                    <li className="d-inline">
                      <button
                        className={`rounded-pill ${
                          NotificationType === "unread" ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          switchNotificationType("unread");
                        }}
                      >
                        Unread
                      </button>
                    </li>
                  </ul>
                </div>
                <NavDropdown.Divider />
                {notificationDataToDisplay.length > 0 ? (
                  notificationDataToDisplay.map((item) => (
                    <React.Fragment key={item?.id}>
                      <NavDropdown.Item>
                        <i className="bi bi-exclamation-circle text-warning"></i>
                        <div className="d-flex w-100">
                          <div className="right-notification">
                            <h6>{item?.title}</h6>
                            <p>{item?.body}</p>
                          </div>
                          <div className="d-flex justify-content-between align-items-end flex-column right-notification">
                            {/* <p>3 hrs ago</p> */}
                            <span
                              className={
                                item?.status !== 1 ? "redBg circle" : ""
                              }
                            ></span>
                          </div>
                        </div>
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                    </React.Fragment>
                  ))
                ) : (
                  <div className="no-messages d-flex align-items-center">
                    <p className="mx-auto mt-2">
                      You have no notifications at the moment.
                    </p>
                  </div>
                )}

                {NotificationData.length > 0 && (
                  <NavDropdown.Item
                    className="text-center view-all"
                    onClick={() => navigate("/notification_page")}
                  >
                    View All
                  </NavDropdown.Item>
                )}
                {/* <NavDropdown.Item className="text-center view-all" onClick={() => navigate("/notification_page")}>
    View All
  </NavDropdown.Item> */}
              </NavDropdown>
            )}

            <NavDropdown
              className="profile-dropdown"
              title={
                <>
                  <div
                    style={{
                      backgroundImage: `url('${
                        image ? "/assets/Place_Holder.png" : image
                      }')`,
                    }}
                    className="user_profile_header"
                  ></div>
                </>
              }
              // id="profile-dropdown"
              id="basic-nav-dropdown"
            >
              <div className=" px-4 pt-4 ">
                <div className="d-flex border-bottom align-items-start gap-3 pb-4">
                  <div className="profile-container">
                    <div
                      style={{
                        backgroundImage: `url('${
                          image ? "/assets/Place_Holder.png" : image
                        }')`,
                      }}
                      className="user_profile_menu_main"
                    ></div>
                  </div>

                  <div>
                    <h3 className="mb-0">
                      {user_info?.first_name + " " + user_info?.last_name ||
                        "Ronald Richard"}
                    </h3>
                    {user_role === Roles.DENTIST ? (
                      <p className="mb-0 licence_num">
                        {"License Number: " +
                          user_info?.dentist_license_number || "1234567890"}
                      </p>
                    ) : (
                      <p className="mb-0">
                        {user_info?.email || "your@email.com"}
                      </p>
                    )}
                  </div>
                  {user_role === Roles.DENTIST ? (
                    <>
                      <div onClick={share_qr} className="me-0 ms-auto qr_cont">
                        <img width="28" height="28" src={qrImage} alt="QR" />
                      </div>
                    </>
                  ) : user_info?.is_subscription == 1 ? (
                    <>
                      <div className="me-0 ms-auto qr_cont">
                        <img
                          width="28"
                          height="28"
                          src={"/assets/shield.svg"}
                          alt="QR"
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {user_role === Roles.PATIENT && (
                <>
                  <NavDropdown.Item onClick={() => navigate("/my_profile")}>
                    <ImageElement source={"myProfile.svg"} alt={"icon"} />
                    My Profile
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    onClick={() => navigate("/my_subscription")}
                  >
                    <ImageElement source={"mySubscription.svg"} alt={"icon"} />
                    My Subscription
                  </NavDropdown.Item>

                  <NavDropdown.Item onClick={() => navigate("/my_scans")}>
                    <ImageElement source={"myScan.svg"} alt={"icon"} />
                    <span>My Scans</span>
                  </NavDropdown.Item>

                  <NavDropdown.Item onClick={() => navigate("/connected")}>
                    <ImageElement source={"connected_apps.svg"} alt={"icon"} />
                    <span>Connected Apps</span>
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/my_order")}>
                    <ImageElement source={"cart.svg"} alt={"icon"} />
                    <span>My Orders & Payment History</span>
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    onClick={() => navigate("/customer_support")}
                  >
                    <ImageElement
                      source={"customer_support.svg"}
                      alt={"icon"}
                    />
                    <span>Customer Support</span>
                  </NavDropdown.Item>
                </>
              )}

              {user_role === Roles.DENTIST && (
                <>
                  <NavDropdown.Item onClick={() => navigate("/my_profile")}>
                    <ImageElement source={"myProfile.svg"} alt={"icon"} />
                    My Profile
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate("/my_order")}>
                    <ImageElement source={"cart.svg"} alt={"icon"} />
                    <span>My Orders & Payment History</span>
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    onClick={() => navigate("/customer_support")}
                  >
                    <ImageElement
                      source={"customer_support.svg"}
                      alt={"icon"}
                    />
                    <span>Customer Support</span>
                  </NavDropdown.Item>
                </>
              )}
              <NavDropdown.Item onClick={() => handleShowModal()}>
                <ImageElement source={"logout.svg"} alt={"icon"} />
                <span>Logout</span>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </div>
      </Navbar>

      {/* <CustomModal
          show={showModal}
          handleClose={handleCloseModal}
          title="Modal Title"
          footer={<Button variant="primary">Save changes</Button>}
        >
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>
            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Password" />
            </Form.Group>
          </Form>
        </CustomModal> */}
      <CustomModal
        className="header-modal qr_modal custom_modal"
        show={QRModal}
        handleClose={handleCloseModal}
        // route={currentRoute}
        dialogClassName="payment-history order-dialog" // Pass the custom class name for the modal-dialog
      >
        <div className="QR-main-con d-flex flex-md-row flex-column justify-content-md-between ">
          <div className="QR-Inner mx-auto">
            <div className="text-center mb-1 ">
              <ImageElement
                source={"Apple_badge.svg"}
                alt={"icon"}
                max-width="100px"
                className="d-block mx-auto mb-3"
              />
              <img className="mb-4 qr_image" src={qrImage} alt="qr_image" />
              {/* <p>Scan to download the app</p> */}
            </div>
            <div className="d-flex align-items-center qrModal">
              <button
                className="modal-default-button rounded-pill w-50% border border-2 text-primary border-primary text-center  mb-md-0 mx-auto me-1 me-md-3 fw-normal"
                onClick={() => copyTextToClipboard(qrLink)}
              >
                {/* <ImageElement className="me-1 w-10" source={"copy_icon.svg"} alt={"icon"} /> */}
                <span className="me-1 w-10">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2582_2591)">
                      <path
                        d="M6.66683 0.416016H1.66683C1.2085 0.416016 0.833496 0.791016 0.833496 1.24935V7.08268H1.66683V1.24935H6.66683V0.416016ZM7.91683 2.08268H3.3335C2.87516 2.08268 2.50016 2.45768 2.50016 2.91602V8.74935C2.50016 9.20768 2.87516 9.58268 3.3335 9.58268H7.91683C8.37516 9.58268 8.75016 9.20768 8.75016 8.74935V2.91602C8.75016 2.45768 8.37516 2.08268 7.91683 2.08268ZM7.91683 8.74935H3.3335V2.91602H7.91683V8.74935Z"
                        fill="#305FF2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2582_2591">
                        <rect width="10" height="10" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Share link
              </button>
              <button
                className="default-button modal-primary-btn rounded-pill w-75 text-center mx-auto"
                onClick={() => copyTextToClipboard(qrImage)}
              >
                <span className="me-1">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 9 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 7.06827C7.12 7.06827 6.78 7.21888 6.52 7.45482L2.955 5.37149C2.98 5.25602 3 5.14056 3 5.02008C3 4.8996 2.98 4.78414 2.955 4.66867L6.48 2.60542C6.75 2.85643 7.105 3.01205 7.5 3.01205C8.33 3.01205 9 2.33936 9 1.50602C9 0.672691 8.33 0 7.5 0C6.67 0 6 0.672691 6 1.50602C6 1.62651 6.02 1.74197 6.045 1.85743L2.52 3.92068C2.25 3.66968 1.895 3.51406 1.5 3.51406C0.67 3.51406 0 4.18675 0 5.02008C0 5.85341 0.67 6.5261 1.5 6.5261C1.895 6.5261 2.25 6.37048 2.52 6.11948L6.08 8.20783C6.055 8.31325 6.04 8.42369 6.04 8.53414C6.04 9.34237 6.695 10 7.5 10C8.305 10 8.96 9.34237 8.96 8.53414C8.96 7.7259 8.305 7.06827 7.5 7.06827Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Share QR code
              </button>
            </div>
          </div>

          <div className="vertical-separator d-none d-md-flex"></div>

          <div className="horizontal-separator d-sm-flex d-md-none"></div>
          <div className="QR-Inner mx-auto ">
            <div className="text-center mb-1 ">
              <ImageElement
                source={"Google_badge.svg"}
                alt={"icon"}
                max-width="100px"
                className="d-block mx-auto mb-3"
              />
              <img className="mb-4 qr_image" src={qrImage} alt="qr_image" />
              {/* <p>Scan to download the app</p> */}
            </div>
            <div className="d-flex align-items-center qrModal">
              <button
                className="modal-default-button rounded-pill w-75 border border-2 text-primary border-primary text-center mb-0 mb-md-0 mx-auto me-1 me-md-3 fw-normal"
                onClick={() => copyTextToClipboard(qrLink)}
              >
                <span className="me-1 w-10">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2582_2591)">
                      <path
                        d="M6.66683 0.416016H1.66683C1.2085 0.416016 0.833496 0.791016 0.833496 1.24935V7.08268H1.66683V1.24935H6.66683V0.416016ZM7.91683 2.08268H3.3335C2.87516 2.08268 2.50016 2.45768 2.50016 2.91602V8.74935C2.50016 9.20768 2.87516 9.58268 3.3335 9.58268H7.91683C8.37516 9.58268 8.75016 9.20768 8.75016 8.74935V2.91602C8.75016 2.45768 8.37516 2.08268 7.91683 2.08268ZM7.91683 8.74935H3.3335V2.91602H7.91683V8.74935Z"
                        fill="#305FF2"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2582_2591">
                        <rect width="10" height="10" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Share link
              </button>
              <button
                className="default-button modal-primary-btn rounded-pill w-75 text-center mx-auto"
                onClick={() => copyTextToClipboard(qrImage)}
              >
                <span className="me-1">
                  <svg
                    width="9"
                    height="10"
                    viewBox="0 0 9 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 7.06827C7.12 7.06827 6.78 7.21888 6.52 7.45482L2.955 5.37149C2.98 5.25602 3 5.14056 3 5.02008C3 4.8996 2.98 4.78414 2.955 4.66867L6.48 2.60542C6.75 2.85643 7.105 3.01205 7.5 3.01205C8.33 3.01205 9 2.33936 9 1.50602C9 0.672691 8.33 0 7.5 0C6.67 0 6 0.672691 6 1.50602C6 1.62651 6.02 1.74197 6.045 1.85743L2.52 3.92068C2.25 3.66968 1.895 3.51406 1.5 3.51406C0.67 3.51406 0 4.18675 0 5.02008C0 5.85341 0.67 6.5261 1.5 6.5261C1.895 6.5261 2.25 6.37048 2.52 6.11948L6.08 8.20783C6.055 8.31325 6.04 8.42369 6.04 8.53414C6.04 9.34237 6.695 10 7.5 10C8.305 10 8.96 9.34237 8.96 8.53414C8.96 7.7259 8.305 7.06827 7.5 7.06827Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Share QR code
              </button>
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        className="header-modal logout-modal custom_modal"
        show={showModal}
        handleClose={handleCloseModal}
        // route={currentRoute}
        dialogClassName="payment-history order-dialog" // Pass the custom class name for the modal-dialog
      >
        <h4 className="text-center w-100 pb-3">Logout</h4>
        <p className="mb-3 mb-md-5 text-center">
          Are you sure you want to logout?
        </p>
        <Link
          className="default-button primary-btn rounded-pill w-75 d-block text-center mb-3 mx-auto"
          onClick={reduxLogout}
        >
          Yes, Logout
        </Link>
        <Link
          className="default-button rounded-pill w-75 d-block text-center mb-0 mx-auto text-black fw-normal"
          onClick={handleCancel}
        >
          Cancel
        </Link>
      </CustomModal>
      {/* </div> */}
    </>
  );
}
